import ResourceManager from '@/Management/ResourceManager';

export interface DataInfo {
    min: number;
    max: number;
}

const DATA = {
    Int32: { min: -2147483648, max: 2147483647 },
    UInt32: { min: 0, max: 4294967295 },
    Int16: { min: -32768, max: 32767 },
    UInt16: { min: 0, max: 65535 },
    Int64: { min: -9223372036854775808, max: 9223372036854775807 },
    UInt64: { min: 0, max: 18446744073709551615 },
    SByte: { min: -128, max: 127 },
    Byte: { min: 0, max: 255 },
    Single: { min: -3.402823e38, max: 3.402823e38 },
    Double: { min: -1.79769313486232e308, max: 1.79769313486232e308 },
    Decimal: { min: -7.922816251426434e+28, max: 7.922816251426434e+28 },
    CurrencyT: { min: -7.922816251426434e+28, max: 7.922816251426434e+28 }
};

const DATA_ORDER = _.keys(DATA).sort((b1, b2) => { return b2.length - b1.length; });

export function getDotNetTypeInfo(dotNetType): DataInfo {
    for (let i = 0; i < DATA_ORDER.length; i++) {
        let numType = DATA_ORDER[i];
        if (dotNetType.indexOf(numType) > -1) {
            return DATA[numType];
        }
    }
    return null;
}

/**
    * Entfernt alle überschüssigen Dezimalstellen und gibt die neue Zahl zurück
    * @param val
    * @param floatingPrecision
    */
export function truncateDecimals(val: number, floatingPrecision: number): number {
    if (Number.isNullOrUndefined(val))
        return val;

    // Typsicherung 
    if (isNaN(floatingPrecision))
        floatingPrecision = parseInt(floatingPrecision + '');
    if (isNaN(val))
        val = parseFloat(val + '');

    // Parsen fehlgeschlagen
    if (isNaN(floatingPrecision) || isNaN(val))
        return val;

    let num = val + '';
    if (num.indexOf('.') > -1) {
        let length = num.indexOf('.') + (floatingPrecision > 0 ? floatingPrecision + 1 : 0);
        num = num.slice(0, length);
    }
    return parseFloat(num);
}

/**
    * Passt die Zahl der aktuellen Sprache (Kürzen von Nachkommastellen etc.)
    * Rückgabewert ist immer noch eine Zahl
    * @param number
    * @param floatingPrecision
    */
export function toLocaleNumber(number: number, floatingPrecision?: number): number {
    if (Number.isNullOrUndefined(number))
        return number;

    const decimals = checkFloatingPrecision(floatingPrecision);

    const formatedNumber = parseFloat((number + '').replace(/[^0-9+\-Ee.]/g, ''));

    var n = !isFinite(+formatedNumber) ? 0 : +formatedNumber,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        s = null,
        toFixedFix = (n, prec) => {
            var k = Math.pow(10, prec);
            return (Math.round(n * k) / k);
        };
    s = (prec ? toFixedFix(n, prec) : Math.round(n));
        
    return s;
}

/**
    * Gibt die String-Darstellung einer Zahl für die aktuelle Sprache an
    * Hier werden Dezimal- und Tausendertrennzeichen berücksichtigt
    * @param number
    * @param floatingPrecision
    */
export function toLocaleString(number: number, floatingPrecision?: number): string {
    const decimals = checkFloatingPrecision(floatingPrecision);
    const localeNumber = toLocaleNumber(number, decimals);
    if (Number.isNullOrUndefined(localeNumber))
        return '';

    const cultureInfo = ResourceManager.getInstance().getLanguage() ? ResourceManager.getInstance().getLanguage().cultureInfoName : 'en';
    return localeNumber.toLocaleString(cultureInfo, { minimumFractionDigits: decimals });
}

/**
    * Überprüft die FloatingPrecision und gibt, wenn nicht gesetzt, die der aktuellen Sprache zurück
    * @param floatingPrecision
    */
function checkFloatingPrecision(floatingPrecision?: number): number {
    return !Number.isNullOrUndefined(floatingPrecision) ? floatingPrecision : getCurrentLanguageFloatingPrecision();
}

/**
    * Gibt die FloatingPrecision der aktuellen Sprache zurück
    */
function getCurrentLanguageFloatingPrecision(): number {
    const language = ResourceManager.getInstance().getLanguage();
    if (language) {
        return language.floatingPrecision;
    }
    else {
        return 0;
    }
}

export default {
    toLocaleString,
    toLocaleNumber,
    truncateDecimals,
    getDotNetTypeInfo
}